import React from 'react'
import { IconDefinition } from '@fortawesome/fontawesome-svg-core'
import {
  FontAwesomeIcon,
  FontAwesomeIconProps,
} from '@fortawesome/react-fontawesome'
import { twMerge } from 'tailwind-merge'

type IconProps = {
  icon?: IconDefinition
} & Omit<FontAwesomeIconProps, 'icon'>

export const Icon = (props: IconProps) => {
  if (!props.icon) return null
  return (
    <FontAwesomeIcon
      {...props}
      icon={props.icon}
      className={twMerge('', props.className)}
    />
  )
}
